export const config = {
    threeUrl: "http://47.99.177.252:5505/3D/public/level/",
    // threeUrl: "http://192.168.33.121:5500/public/level/",
    
    gisUrl: "http://47.99.177.252:8182/Apps/Sandcastle/gallery/",
    // gisUrl: "//192.168.33.121:5502/Apps/Sandcastle/gallery/",
}